import React from 'react';
import ExportProgressModal from '../Common/ExportProgressModal';

const STATUS_LABELS = {
  queued: 'En cola',
  processing: 'Preparando datos',
  completed: 'Completado',
  failed: 'Error',
};

const EntryGuideDocumentProgressModal = ({
  isOpen,
  guideCode,
  progress,
  onClose,
  allowClose = false,
}) => (
  <ExportProgressModal
    isOpen={isOpen}
    title={`Preparando guía${guideCode ? ` ${guideCode}` : ''}`}
    progress={progress}
    onClose={onClose}
    allowClose={allowClose}
    defaultMessage="Cargando datos para PDF o impresión…"
    itemsLabel="Ítems procesados"
    queuedMessage="Guía con muchos ítems: la preparación corre en segundo plano para evitar cortes de red."
    statusLabels={STATUS_LABELS}
  />
);

export default EntryGuideDocumentProgressModal;
